/**
 * TKS Contribution Collector ABI
 * Deployed on BSC Testnet, Sepolia, Polygon Amoy, Base Sepolia
 */

export const TKS_COLLECTOR_ABI = [
    // View Functions
    {
        inputs: [],
        name: "getPresaleStats",
        outputs: [
            { internalType: "uint256", name: "totalUsd", type: "uint256" },
            { internalType: "uint256", name: "totalTks", type: "uint256" },
            { internalType: "uint256", name: "contributorCount", type: "uint256" },
            { internalType: "uint256", name: "currentTksPerUsd", type: "uint256" },
            { internalType: "bool", name: "paused", type: "bool" },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [{ internalType: "address", name: "user", type: "address" }],
        name: "getUserStats",
        outputs: [
            { internalType: "uint256", name: "usdContributed", type: "uint256" },
            { internalType: "uint256", name: "tksAmount", type: "uint256" },
            { internalType: "uint256", name: "refEarningsUsd", type: "uint256" },
            { internalType: "uint256", name: "refTksEarned", type: "uint256" },
            { internalType: "address", name: "userReferrer", type: "address" },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getNativePrice",
        outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            { internalType: "address", name: "payToken", type: "address" },
            { internalType: "uint256", name: "amount", type: "uint256" },
        ],
        name: "calculateTks",
        outputs: [
            { internalType: "uint256", name: "tks", type: "uint256" },
            { internalType: "uint256", name: "usd", type: "uint256" },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "tksPerUsd",
        outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "totalRaisedUsd",
        outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "totalTksSold",
        outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [{ internalType: "address", name: "user", type: "address" }],
        name: "tksEarned",
        outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [{ internalType: "address", name: "user", type: "address" }],
        name: "contributionsUsd",
        outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getContributorsCount",
        outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "isPaused",
        outputs: [{ internalType: "bool", name: "", type: "bool" }],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "fundsReceiver",
        outputs: [{ internalType: "address", name: "", type: "address" }],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "referralPercent",
        outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [{ internalType: "address", name: "", type: "address" }],
        name: "acceptedTokens",
        outputs: [{ internalType: "bool", name: "", type: "bool" }],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [{ internalType: "address", name: "", type: "address" }],
        name: "isStablecoin",
        outputs: [{ internalType: "bool", name: "", type: "bool" }],
        stateMutability: "view",
        type: "function",
    },
    // Write Functions
    {
        inputs: [],
        name: "contribute",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [{ internalType: "address", name: "ref", type: "address" }],
        name: "contributeWithReferral",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            { internalType: "address", name: "payToken", type: "address" },
            { internalType: "uint256", name: "amount", type: "uint256" },
        ],
        name: "contributeWithToken",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            { internalType: "address", name: "payToken", type: "address" },
            { internalType: "uint256", name: "amount", type: "uint256" },
            { internalType: "address", name: "ref", type: "address" },
        ],
        name: "contributeWithTokenAndReferral",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    // Events
    {
        anonymous: false,
        inputs: [
            { indexed: true, internalType: "address", name: "user", type: "address" },
            { indexed: true, internalType: "address", name: "payToken", type: "address" },
            { indexed: false, internalType: "uint256", name: "payAmount", type: "uint256" },
            { indexed: false, internalType: "uint256", name: "usdValue", type: "uint256" },
            { indexed: false, internalType: "uint256", name: "tksAmount", type: "uint256" },
        ],
        name: "Contributed",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            { indexed: true, internalType: "address", name: "user", type: "address" },
            { indexed: true, internalType: "address", name: "referrer", type: "address" },
            { indexed: false, internalType: "uint256", name: "referralUsd", type: "uint256" },
            { indexed: false, internalType: "uint256", name: "referralTks", type: "uint256" },
        ],
        name: "ContributedWithReferral",
        type: "event",
    },
] as const

// TKS Token address (same on all networks)
export const TKS_TOKEN_ADDRESS = process.env.NEXT_PUBLIC_TKS_TOKEN_ADDRESS || "0x8664E4345E2181032F1dDfbCCE210456C0eD8401"

// TKS Collector addresses by chain ID
export const TKS_COLLECTOR_ADDRESSES: Record<number, `0x${string}`> = {
    // Testnet
    97: (process.env.NEXT_PUBLIC_TKS_COLLECTOR_BSC_TESTNET || "0x450d398ef477097D0DDDAbE2BB5Aca37a387ba2B") as `0x${string}`,
    11155111: (process.env.NEXT_PUBLIC_TKS_COLLECTOR_SEPOLIA || "0x450d398ef477097D0DDDAbE2BB5Aca37a387ba2B") as `0x${string}`,
    80002: (process.env.NEXT_PUBLIC_TKS_COLLECTOR_POLYGON_AMOY || "0x450d398ef477097D0DDDAbE2BB5Aca37a387ba2B") as `0x${string}`,
    84532: (process.env.NEXT_PUBLIC_TKS_COLLECTOR_BASE_SEPOLIA || "0x450d398ef477097D0DDDAbE2BB5Aca37a387ba2B") as `0x${string}`,
    // Mainnet
    56: (process.env.NEXT_PUBLIC_TKS_COLLECTOR_BSC || "0x8bC09932093Cff9019b7822B8835Be9Ad6ef91Ee") as `0x${string}`,
    1: (process.env.NEXT_PUBLIC_TKS_COLLECTOR_ETH || "0x8bC09932093Cff9019b7822B8835Be9Ad6ef91Ee") as `0x${string}`,
    137: (process.env.NEXT_PUBLIC_TKS_COLLECTOR_POLYGON || "0x8bC09932093Cff9019b7822B8835Be9Ad6ef91Ee") as `0x${string}`,
    8453: (process.env.NEXT_PUBLIC_TKS_COLLECTOR_BASE || "0x8bC09932093Cff9019b7822B8835Be9Ad6ef91Ee") as `0x${string}`,
}

// Stablecoin addresses by chain ID
export const STABLECOIN_ADDRESSES: Record<number, { symbol: string; address: `0x${string}`; decimals: number }[]> = {
    // Testnet
    97: [ // BSC Testnet
        { symbol: "USDT", address: "0x221c5b1a293aac1187ed3a7d7d2d9ad7fe1f3fb0", decimals: 18 },
        { symbol: "USDC", address: "0x64544969ed7EBf5f083679233325356EbE738930", decimals: 18 },
        { symbol: "DAI", address: "0xEC5dCb5Dbf4B114C9d0F65BcCAb49EC54F6A0867", decimals: 18 },
    ],
    11155111: [ // Sepolia
        { symbol: "USDT", address: "0xaA8E23Fb1079EA71e0a56F48a2aA51851D8433D0", decimals: 6 },
        { symbol: "USDC", address: "0x1c7D4B196Cb0C7B01d743Fbc6116a902379C7238", decimals: 6 },
        { symbol: "DAI", address: "0x3e622317f8C93f7328350cF0B56d9eD4C620C5d6", decimals: 18 },
    ],
    80002: [], // Polygon Amoy - native only
    84532: [ // Base Sepolia
        { symbol: "USDT", address: "0x4dbd49a3ae90aa5f13091ccd29a896cbb5b171eb", decimals: 6 },
        { symbol: "USDC", address: "0x036CbD53842c5426634e7929541eC2318f3dCF7e", decimals: 6 },
        { symbol: "DAI", address: "0x50c5725949A6F0c72E6C4a641F24049A917DB0Cb", decimals: 18 },
    ],
    // Mainnet
    56: [ // BSC
        { symbol: "USDT", address: "0x55d398326f99059fF775485246999027B3197955", decimals: 18 },
        { symbol: "USDC", address: "0x8AC76a51cc950d9822D68b83fE1Ad97B32Cd580d", decimals: 18 },
        { symbol: "DAI", address: "0x1AF3F329e8BE154074D8769D1FFa4eE058B1DBc3", decimals: 18 },
    ],
    1: [ // Ethereum
        { symbol: "USDT", address: "0xdAC17F958D2ee523a2206206994597C13D831ec7", decimals: 6 },
        { symbol: "USDC", address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48", decimals: 6 },
        { symbol: "DAI", address: "0x6B175474E89094C44Da98b954EedeAC495271d0F", decimals: 18 },
    ],
    137: [ // Polygon
        { symbol: "USDT", address: "0xc2132D05D31c914a87C6611C10748AEb04B58e8F", decimals: 6 },
        { symbol: "USDC", address: "0x3c499c542cEF5E3811e1192ce70d8cC03d5c3359", decimals: 6 },
        { symbol: "DAI", address: "0x8f3Cf7ad23Cd3CaDbD9735AFf958023239c6A063", decimals: 18 },
    ],
    8453: [ // Base
        { symbol: "USDC", address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913", decimals: 6 },
        { symbol: "DAI", address: "0x50c5725949A6F0c72E6C4a641F24049A917DB0Cb", decimals: 18 },
    ],
}

// ERC20 ABI for token approvals
export const ERC20_ABI = [
    {
        inputs: [
            { internalType: "address", name: "spender", type: "address" },
            { internalType: "uint256", name: "amount", type: "uint256" },
        ],
        name: "approve",
        outputs: [{ internalType: "bool", name: "", type: "bool" }],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            { internalType: "address", name: "owner", type: "address" },
            { internalType: "address", name: "spender", type: "address" },
        ],
        name: "allowance",
        outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [{ internalType: "address", name: "account", type: "address" }],
        name: "balanceOf",
        outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
        stateMutability: "view",
        type: "function",
    },
] as const
